module.exports = __webpack_public_path__ + "static/media/BTC.ef2f7433.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/BTC.png
// module id = 391
// module chunks = 0